import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { CustomsOfficeModel, CustomsOfficeService } from '@railmybox/api-booking';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'rmb-customs-office-select',
  templateUrl: './customs-office-select.component.html',
  styleUrls: ['./customs-office-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(CustomsOfficeSelectComponent)],
  standalone: false,
})
export class CustomsOfficeSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private customsOfficeService = inject(CustomsOfficeService);

  customsOffice$: Observable<CustomsOfficeModel[]>;
  searchControl: FormControl = new FormControl(undefined);
  selectedName: string;
  @Input() clearable = false;

  ngOnInit(): void {
    this.customsOffice$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.customsOfficeService.listCustomsOffices({ query }, 20) : of([])))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(customOffice: CustomsOfficeModel): void {
    this.selectedName = `${customOffice?.referenceNumber} - ${customOffice?.name}`;
    this.value = customOffice?.id;
    this.onChange(customOffice?.id);
    this.changed.emit(customOffice?.id);
  }

  async writeValue(value: string): Promise<void> {
    super.writeValue(value);

    if (!value) {
      return;
    }
    const customOffice = await this.customsOfficeService
      .listCustomsOffices({ query: value })
      .toPromise()
      .then((filteredValues) => filteredValues.find((customOffice) => customOffice.id === value));

    // In case no entry found with that id
    if (!customOffice) {
      return;
    }

    this.value = customOffice.id;
    this.selectedName = `${customOffice.referenceNumber} - ${customOffice.name}`;
  }
}
